export default __webpack_public_path__ + "static/media/soil.6eed77a6.svg";